export function getParams (state){
    return state.params
}



// WEBPACK FOOTER //
// ./src/modules/sales_budget_by_contacts_warehouses/getters.js